import { render, staticRenderFns } from "./WidgetReviewsHorizontalScrollPc.vue?vue&type=template&id=b34202da"
import script from "./WidgetReviewsHorizontalScrollPc.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsHorizontalScrollPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports